import styled from "styled-components";
import Text from "../text";

const Caption = styled(Text)`
  font-size: 13px;
  font-weight: 400;
`;

export default Caption;
